<template>
	<div class="modal-card large">
		<div class="modal-card-head">
			<div class="modal-card-title">Choose a portfolio</div>
			<div class="modal-close-button" @click="$emit('close')"></div>
		</div>
		<div class="modal-card-body">
			<div class="mx-4 my-4">
				<div class="columns">
					<div class="column">
						<b-field horizontal label="Portfolio">
							<b-select placeholder="Select a portfolio" expanded v-model="portfolioId">
								<option v-for="p in portfolios" :value="p.Id">{{ p.Name }}</option>
							</b-select>
						</b-field>
					</div>
					<div class="column is-3">
						<b-button class="is-primary" @click="saveToPortfolio">Add {{ SelectedIds.length }} aircraft to portfolio</b-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				portfolioId: "",
				portfolios: []
			}
		},
		props: {
			SelectedIds: Array
		},
		created() {
			this.$http.get("api/portfolio/tagsinput")
				.then(resp => {
					this.portfolios = resp.data;
				})
		},
		methods: {
			saveToPortfolio() {
				this.$http.post("api/aircraft/existing/portfolio", { SelectedIds: this.SelectedIds, PortfolioId: this.portfolioId })
					.then(resp => {
						if (resp.data != null && resp.data == true) {
							this.$buefy.toast.open({
								message: "Aircraft saved to portfolio.",
								type: "is-success"
							});
							this.$parent.close();
						} else {
							this.$buefy.toast.open({
								message: "Failed to save to portfolio.",
								type: "is-danger"
							});
						}
					}).catch(err => {
						console.error(err);
					})
			}
		}
	}
</script>
